import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export async function updateCronSettings(status:any) {
  try {
    const callParams = await getCallParams("POST",status);
    const response = await makeCall(
      urls.UPDATECRONSETTINGS,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getCronSettings() {
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(
        urls.GETCRONSETTINGS,
        callParams
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
  